<template>
    <table v-if="!isSpScreen">
        <tr>
            <th scope="row">
                <div class="th-wrapper">
                    <div>基本料金</div>
                    <div class="weak">/年</div>
                </div>
            </th>
            <th v-for="plan in plans" :key="plan.id" scope="col">
                <div>{{ plan.name }}</div>
                <div v-if="plan.price === '0'" class="price free">無料</div>
                <div v-else class="price">
                    <span>{{ plan.price }}</span
                    ><span>円</span>
                </div>
            </th>
        </tr>
        <tr>
            <th scope="row">
                <div class="th-wrapper">
                    <div>取引件数</div>
                    <div class="weak">/年</div>
                </div>
            </th>
            <td v-for="plan in plans" :key="plan.id">〜{{ plan.limit }}件</td>
        </tr>
        <tr>
            <th scope="row">
                <div class="th-wrapper">対応取引所</div>
            </th>
            <td v-for="plan in plans" :key="plan.id">
                <div v-if="plan.groupBEnabled">
                    <div>グループA</div>
                    <div>&</div>
                    <div>グループB</div>
                </div>
                <div v-else>グループAのみ</div>
            </td>
        </tr>
        <tr>
            <th scope="row">
                <div class="th-wrapper">
                    <div>DeFi・NFT</div>
                    <div>データ対応</div>
                </div>
            </th>
            <td v-for="plan in plans" :key="plan.id">
                <img v-if="plan.defiEnabled" src="@/assets/images/icon_apply.svg" alt="対応" />
                <img v-else src="@/assets/images/icon_cancel.svg" alt="非対応" />
            </td>
        </tr>
    </table>
    <!-- SP版の場合、テーブルの行と列を逆転させて表示 -->
    <table v-else>
        <tr>
            <th scope="row">
                <div class="th-wrapper">
                    <div>基本料金</div>
                    <div class="weak">/年</div>
                </div>
            </th>
            <th scope="row">
                <div class="th-wrapper">
                    <div>取引件数</div>
                    <div class="weak">/年</div>
                </div>
            </th>
            <th scope="row">
                <div class="th-wrapper">対応取引所</div>
            </th>
            <th scope="row">
                <div class="th-wrapper">
                    <div>DeFi・NFT</div>
                    <div>データ対応</div>
                </div>
            </th>
        </tr>

        <tr v-for="plan in plans" :key="plan.id">
            <th scope="col">
                <div>{{ plan.name }}</div>
                <div v-if="plan.price === '0'" class="price free">無料</div>
                <div v-else class="price">
                    <span>{{ plan.price }}</span
                    ><span>円</span>
                </div>
            </th>
            <td>〜{{ plan.limit }}件</td>
            <td>
                <div v-if="plan.groupBEnabled">
                    <div>グループA</div>
                    <div>&</div>
                    <div>グループB</div>
                </div>
                <div v-else>グループAのみ</div>
            </td>
            <td>
                <img v-if="plan.defiEnabled" src="@/assets/images/icon_apply.svg" alt="対応" />
                <img v-else src="@/assets/images/icon_cancel.svg" alt="非対応" />
            </td>
        </tr>
    </table>
</template>

<script>
import { mapGetters } from 'vuex';
import { deserialize } from '@/components/pages/subscriptions/adapter/personal.js';

export default {
    data() {
        return {
            plans: [],
        };
    },
    computed: {
        ...mapGetters(['isSpScreen']),
    },
    mounted() {
        this.getPlans();
    },
    methods: {
        async getPlans() {
            const response = await this.$store.dispatch('apiRequest', {
                url: '/subscription/get_plan',
            });
            if (response?.status !== 200) return;
            this.plans = deserialize.getPlans(response.data);
        },
    },
};
</script>

<style scoped lang="scss">
table {
    margin: 0;
    table-layout: fixed;
    border-collapse: separate;
    border-spacing: 1px;
    width: 100%;
    max-width: 727px;
    line-height: 1.5;
}
th,
td {
    height: 80px;
    padding: 15px 2px;
    font-size: var(--fz12);
    text-align: center;
    font-weight: normal;
    vertical-align: middle;
    &:not(.empty) {
        background-color: #fff;
    }
    .price {
        margin-top: 4px;
        font-size: var(--fz14);
        & > span:first-child {
            font-size: var(--fz18);
            font-weight: 700;
        }
    }
    .free {
        font-weight: 700;
        color: #e84961;
    }
}
th[scope='row'] {
    background-color: #d9d9d9;
    font-size: var(--fz14);
    font-weight: bold;

    .th-wrapper {
        display: grid;
        align-items: center;
        justify-content: center;
    }
    .weak {
        text-align: left;
        font-weight: normal;
    }
}
td img {
    width: 16px;
    height: 16px;
}
</style>
